export class LazyComponent {
  constructor(private readonly resolver: () => Promise<any>) {
  }

  resolve() {
    return this.resolver();
  }
}

export const NothingSelectedView = new LazyComponent(() => import("@omni/components/shared/nothing-selected-view/nothing-selected-view").then(m => m.NothingSelectedView));
export const ContactPageComponent = new LazyComponent(() => import("@omni/components/contact/contact-page/contact-page").then(m => m.ContactPageComponent));
export const ContactSpotlightComponent = new LazyComponent(() => import("@omni/components/contact/contact-spotlight/contact-spotlight.component").then(m => m.ContactSpotlightComponent));
export const ExternalAppFrameComponent = new LazyComponent(() => import("@omni/components/ext-app-frame/ext-app-frame").then(m => m.ExternalAppFrameComponent));